// extracted by mini-css-extract-plugin
export default {"linkBubbleMenu":"EditorContainer_linkBubbleMenu__Ub2L0","editor":"EditorContainer_editor__NA+Lg"};